// extracted by mini-css-extract-plugin
module.exports = {"plainText":"plainTextWrapper__plainText___l-vVx","labelText":"plainTextWrapper__labelText___ChZmd"};